const CLIENT_ERROR = "CLIENT_ERROR";
const SERVER_ERROR = "SERVER_ERROR";
const TIMEOUT_ERROR = "TIMEOUT_ERROR";
const CONNECTION_ERROR = "CONNECTION_ERROR";
const NETWORK_ERROR = "NETWORK_ERROR";
const CANCEL_ERROR = "CANCEL_ERROR";

class ErrorHandler {
  constructor(opts) {
    // Default opts
    this.opts = opts;

    // Bindings
    this.handle = this.handle.bind(this);
    this.parseClientErrors = this.parseClientErrors.bind(this);
  }

  handle(response, displayMessage = true) {
    let errorMessage =
      response.data && response.data.message
        ? response.data.message
        : "Unknown error";

    switch (response.problem) {
      case CLIENT_ERROR:
        // Check do we need additional error message parsing
        errorMessage = this.parseClientErrors(response);
        break;

      case SERVER_ERROR:
        errorMessage = "Error while accessing our service";
        break;

      case TIMEOUT_ERROR:
        errorMessage = "Timeout Error";
        break;

      case CONNECTION_ERROR:
        errorMessage = "Connection Error";
        break;

      case NETWORK_ERROR:
        errorMessage = "Network Error";
        break;

      case CANCEL_ERROR:
        errorMessage = "Request has been cancelled";
        break;

      default:
        errorMessage = "Error while accessing our service";
    }

    if (displayMessage) {
      this.displayErrorMessage(errorMessage);
    }

    throw new Error(errorMessage);
  }

  parseClientErrors(response) {
    const errorMessage =
      response.data.meta && response.data.meta.message
        ? response.data.meta.message
        : response.data.message;

    let errorMessages = [errorMessage];

    // Validation Messages
    if (
      response.status >= 400 &&
      response.status < 500 &&
      response.data.errors &&
      response.data.errors.length
    ) {
      errorMessages = [];

      response.data.errors.forEach(item => {
        errorMessages.push(item.messages[0]);
      });
    }

    return errorMessages.join("\n");
  }

  displayErrorMessage = message => {
    throw new Error(message);
  };
}

export default ErrorHandler;
